module.exports = __webpack_public_path__ + "static/media/sample_3-10.6a04ce56.jpg";